function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var POP = 'Navigation/POP';
var POP_TO_TOP = 'Navigation/POP_TO_TOP';
var PUSH = 'Navigation/PUSH';
var RESET = 'Navigation/RESET';
var REPLACE = 'Navigation/REPLACE';
var COMPLETE_TRANSITION = 'Navigation/COMPLETE_TRANSITION';
var pop = function pop(payload) {
  return _objectSpread({
    type: POP
  }, payload);
};
var popToTop = function popToTop(payload) {
  return _objectSpread({
    type: POP_TO_TOP
  }, payload);
};
var push = function push(payload) {
  return _objectSpread({
    type: PUSH
  }, payload);
};
var reset = function reset(payload) {
  return _objectSpread({
    type: RESET,
    key: null
  }, payload);
};
var replace = function replace(payload) {
  return _objectSpread({
    type: REPLACE
  }, payload);
};
var completeTransition = function completeTransition(payload) {
  return _objectSpread({
    type: COMPLETE_TRANSITION
  }, payload);
};
export default {
  POP: POP,
  POP_TO_TOP: POP_TO_TOP,
  PUSH: PUSH,
  RESET: RESET,
  REPLACE: REPLACE,
  COMPLETE_TRANSITION: COMPLETE_TRANSITION,
  pop: pop,
  popToTop: popToTop,
  push: push,
  reset: reset,
  replace: replace,
  completeTransition: completeTransition
};